import React from "react";
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import classNames from "classnames";
import ImageGallery from "react-image-gallery";
// import Datetime from "react-datetime";
import moment from 'moment';
import numeral from 'numeral';
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import Snackbar from '@material-ui/core/Snackbar';
// import * as _ from 'lodash';

// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import InputLabel from "@material-ui/core/InputLabel";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import Tooltip from "@material-ui/core/Tooltip";

// react-dates Calendar dependencies
import {
    SingleDatePicker
    //DateRangePicker,
    //DayPickerRangeController,
} from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import WbSunny from "@material-ui/icons/WbSunny";
import Brightness3 from "@material-ui/icons/Brightness3";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Accordion from "../../components/Accordion/Accordion.jsx";
// import InfoArea from "../../components/InfoArea/InfoArea.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Card from "../../components/Card/Card.jsx";
// import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardFooter from "../../components/Card/CardFooter.jsx";
import InfoCardVEC from "../../components/common/InfoCardVEC";

/**
 * TODO: En un futuro mirar como pintar el mapa para tour
 * */
// import SectionMap from "./Sections/SectionMap";
import FooterSection from "../LandingPage/Sections/FooterSection";
import CustomNotification from "../LandingPage/Sections/CustomNotification";

import productStyle from "../../assets/jss/material-kit-pro-react/views/productStyle.jsx";

import calculateEndDate from "../../utils/calculateEndDate";
import isHighSeason from "../../utils/isHighSeason";
import { STATICS_URL } from "../../config/constants";
import { IVA } from "../../config/constants";
import { getTour } from '../../actions/toursActions';

moment.locale('es');

let bookingPrice = 0;
let bookingHighSeason = null;
let bookingNumberOfPersons = 1;

class TourDetailPage extends React.Component {
    /**
     * TODO: En donde se va a añadir la calificacion del usuario?
     */
    constructor(props) {
        super(props);
        this.state = {
            openNotification: false,
            messageNotification: '',
            variantNotification: '',
            colorSelect: "0",
            sizeSelect: "0",
            startDate: null,
            endDate: null,
            focused: false,
            maxBookableDate: null,
            minBookableDate: null,
            personsNumber: 1,
            float: null,
            maxPersonsLimit: null,
            errors: {}
        };
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    componentWillReceiveProps(newProps) {
        if (newProps.errors) {
            this.setState({ errors: newProps.errors });
        }
    };

    componentWillMount() {
        bookingPrice = 0;
        bookingHighSeason = null;
        bookingNumberOfPersons = 1;

        this.props.getTour(this.props.match.params.id);
        setTimeout(() => {
            !!this.props.toursReducer.tour._id ? console.log() : this.props.history.goBack();
        }, 10000);

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    };

    componentWillUpdate(props, state) {
        const { startDate, endDate } = state;
        if (startDate!==null && endDate!==null){
            this.calculateBookingPrice(startDate, endDate);
        }
    };

    onChangeCustomInput = () => e => {
        this.setState({ [e.target.id]: e.target.value });
        if (e.target.id === 'personsNumber') bookingNumberOfPersons = e.target.value;
        this.calculateBookingPrice(this.state.startDate, this.state.endDate);
    };

    clearCalculatedPrice = () => {
        this.calculateBookingPrice(this.state.startDate, this.state.endDate);
    };

    calculateBookingPrice(startDate, endDate) {
        if (startDate!==null && endDate!==null) {
            const { tour } = this.props.toursReducer;
            bookingHighSeason = isHighSeason(startDate, endDate);
            if (bookingHighSeason===true) {
                bookingPrice = (tour.pricing.high_season * bookingNumberOfPersons);
            } else {
                bookingPrice = (tour.pricing.low_season * bookingNumberOfPersons);
            }
        }
    };

    goToBookingForm = () => {
        const { tour } = this.props.toursReducer;
        const { authReducer } = this.props;
        const { personsNumber, endDate, startDate } = this.state;

        if (startDate!==null && endDate!==null) {
            if (personsNumber>=tour.min_persons && personsNumber<=tour.max_persons) {

                let bookingInfo = {
                    start: startDate.format("DD/MM/YYYY"),
                    end: endDate.format("DD/MM/YYYY"),
                    tourId: tour._id,
                    tourName: tour.name,
                    persons: personsNumber,
                    tourist_id: authReducer.isAuthenticated ? authReducer.user._id : '',
                    totalPrice: bookingPrice,
                    tax: bookingPrice * IVA
                };

                localStorage.setItem('BOOKING_INFO', JSON.stringify(bookingInfo));
                this.props.history.push('/booking-tour');

            } else {
                this.handleClickNotification(`El número de personas admitido debe estar entre ${tour.min_persons} y ${tour.max_persons}`, 'warning');
            }

        } else {
            this.handleClickNotification('Por favor selecciona la fecha de Inicio', 'warning');
        }
    };

    render() {
        const { classes, toursReducer } = this.props;
        const { tour } = toursReducer;

        const images = [];

        tour.photos.forEach((image, idx) => {
            if (image.is_360 === false) {
                images.push({
                    original: STATICS_URL+image.path,
                    thumbnail: STATICS_URL+image.path,
                    originalAlt: tour.name+" "+idx
                })
            }
        });

        return (
            <div className={classes.productPage}>
                {/* Custom Notification */}
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                    <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                </Snackbar>
                {/* End Custom Notification */}

                <Helmet>
                    <meta charSet="utf-8" />
                    {!!tour.name ? <title>{tour.name} | Vivamos el Campo - Turismo Rural</title> : null}
                    {!!tour._id ? <link rel="canonical" href={"https://vivamoselcampo.co/tour/"+tour._id} /> : null}
                    {!!tour.description ? <meta name="description" content={tour.description} /> : null}
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 130,
                        color: "white"
                    }}
                />
                <Parallax
                    image={require("../../assets/img/bg-tour-detail.jpg")}
                    filter="success"
                    className={classes.pageHeader}
                >
                </Parallax>
                <div className={classNames(classes.section, classes.sectionGray)}>
                    <div className={classes.container}>
                        <div className={classNames(classes.main, classes.mainRaised)}>
                            <GridContainer>
                                <GridItem md={8} sm={12} className={classes.dashed}>
                                    {images.length === 1 ?
                                        <img
                                            className={classNames( classes.imgRaised, classes.imgFluid, classes.rounded )}
                                            src={images[0].original}
                                            alt={tour.name}
                                        />
                                        :
                                        <ImageGallery
                                            showFullscreenButton={false}
                                            showBullets={true}
                                            showPlayButton={true}
                                            startIndex={0}
                                            items={images}
                                            lazyLoad={true}
                                            showThumbnails={false}
                                            useBrowserFullscreen={true}
                                            slideDuration={450}
                                            slideInterval={4000}
                                            swipeThreshold={30}
                                        />
                                    }
                                </GridItem>

                                <GridItem md={4} sm={12} className={classes.dashed}>
                                    {isMobile ?
                                        <h3 className={classes.title}>{tour.name}</h3>
                                        :
                                        <h2 className={classes.title}>{tour.name}</h2>
                                    }
                                    {!!tour.location ?
                                        <h5>{tour.location.city.name}, {tour.location.department.name}</h5>
                                        :
                                        null
                                    }

                                    <h4><strong> <WbSunny/> {tour.duration} día(s) <Brightness3/> {tour.duration-1} noche(s)</strong></h4>

                                    {(!!tour.pricing.high_season && !!tour.pricing.low_season && (tour.pricing.high_season===tour.pricing.low_season)) ?
                                        <h5 className={classes.mainPriceMini}>Desde COP$ {numeral(tour.pricing.high_season).format('0,0')} por persona</h5>
                                        :
                                        <div>
                                            <h5 className={classes.mainPriceMini}>Desde COP$ {numeral(tour.pricing.high_season).format('0,0')} por persona, Temp. Alta</h5>
                                            <h5 className={classes.mainPriceMini}>Desde COP$ {numeral(tour.pricing.low_season).format('0,0')} por persona, Temp. Baja</h5>
                                        </div>
                                    }

                                    <br/>

                                    <h5>{tour.shortDescription}</h5>
                                </GridItem>

                                <GridItem md={12} sm={12} className={classes.dashed}>

                                    <hr/>

                                    <GridContainer>
                                        <GridItem md={3} sm={12} xs={12} className={classes.dashed}>
                                            <FormControl fullWidth className={classes.selectFormControl}>
                                                {/* CheckIn DatePicker */}
                                                <SingleDatePicker
                                                    date={this.state.startDate}
                                                    onDateChange={ date => {

                                                        let endDate = calculateEndDate(date, tour.duration);

                                                        this.clearCalculatedPrice();
                                                        // NOTE: componentWillUpdate() will fired

                                                        // let maxBookableDate = _.chain(tour.bookings).filter((d)=>{
                                                        //     return moment(d.start).isAfter(date, 'days');
                                                        // }).orderBy((d)=>{ return moment(d.start);}).map('start').value();
                                                        //
                                                        // this.setState({ maxBookableDate: maxBookableDate[0] });

                                                        this.setState({ startDate:date, endDate });

                                                        //
                                                        // let minBookableDate = _.chain(tour.bookings).filter((d)=>{
                                                        //     return moment(d.start).isBefore(date, 'days');
                                                        // }).orderBy((d)=>{ return moment(d.end);}, ['desc']).map('end').value();
                                                        //
                                                        // this.setState({ minBookableDate: minBookableDate[0] });
                                                        // this.setState({ startDate:date, endDate });

                                                    }}
                                                    focused={this.state.focused}
                                                    onFocusChange={({ focused }) => this.setState({ focused })}
                                                    id="your_unique_id"
                                                    numberOfMonths={1}
                                                    isOutsideRange={this.isBlocked}
                                                    placeholder={"Inicio"}
                                                    displayFormat={'DD/MMM/YYYY'}
                                                    showClearDate={true}
                                                    hideKeyboardShortcutsPanel={true}
                                                />
                                                {/* End CheckIn DatePicker */}
                                                <small>
                                                    COP${' '}
                                                    {numeral(bookingPrice).format('0,0')}

                                                    {bookingHighSeason!==null ?
                                                        bookingHighSeason===true ? " - Temporada Alta" : " - Temporada Baja"
                                                        :
                                                        null
                                                    }
                                                </small>
                                            </FormControl>
                                        </GridItem>

                                        <GridItem md={5} sm={12} xs={12} className={classes.dashed}>
                                            <GridContainer>
                                                <GridItem md={6} sm={6} xs={6} className={classes.vecMaxPContainer+" "+classes.dashed}>
                                                    <CustomInput
                                                        id="personsNumber"
                                                        formControlProps={{ fullWidth: true, className:classes.vecMaxPersInput }}
                                                        inputProps={{
                                                            type: "number",
                                                            defaultValue: this.state.personsNumber,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem md={6} sm={6} xs={6} className={classes.vecLabelContainer+" "+classes.dashed}>
                                                    <p className={classes.vecLabel}>Pasajero(s)</p>
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>

                                        <GridItem md={4} sm={12} xs={12} className={classes.dashed+" "+classes.vecButtonsContainer}>
                                            <Button fullWidth={true} onClick={this.goToBookingForm} color="success">
                                                Reservar
                                            </Button>
                                        </GridItem>
                                    </GridContainer>

                                    <hr/>

                                    <InfoCardVEC />

                                    <Card className={classes.vecCardDetails}>
                                        <CardBody>
                                            <p>{tour.description}</p>
                                            <p><strong>Encargado: </strong>{tour.owner}</p>
                                        </CardBody>
                                    </Card>

                                    <Accordion
                                        active={0}
                                        activeColor="success"
                                        collapses={[
                                            {
                                                title: "Políticas",
                                                content: (
                                                    <ul>
                                                        <li><strong>No. mínimo de personas: </strong>{tour.min_persons}</li>
                                                        <li><strong>No. máximo de personas: </strong>{tour.max_persons}</li>
                                                        {!!tour.observations ? <li><strong>Otras observaciones: </strong>{tour.observations}</li> : null}
                                                    </ul>
                                                )
                                            },
                                            {
                                                title: "Actividades",
                                                content: (
                                                    <ul>
                                                        { (!!tour.activities && tour.activities.length>0) ?
                                                            tour.activities.map(activity => <li key={activity}>{activity}</li>)
                                                            :
                                                            <li>No hay actividades para mostrar</li>}
                                                    </ul>
                                                )
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </div>

                <FooterSection />
            </div>
        );
    };

    isBlocked = (day) => {
        const { tour } = this.props.toursReducer;

        if (!!this.state.maxBookableDate) {
            let isInFuture = day.startOf("day").isSameOrAfter(this.state.maxBookableDate, "day");
            let isInPast = day.startOf("day").isSameOrBefore(this.state.minBookableDate, "day");
            return isInFuture || isInPast;
        } else {

            for(let BLOCKED_RANGE of tour.bookings){
                let range = BLOCKED_RANGE;
                let isInRange = day.startOf("day").isBetween(range.start, range.end, "days", "[]");
                let isInPast = day.startOf("day").isSameOrBefore(moment(), "day");

                if(isInRange || isInPast){
                    return true;
                }
            }
            return false;
        }

    }
}

TourDetailPage.propTypes = {
    getTour: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    toursReducer: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer,
    toursReducer: state.toursReducer
});

export default connect(mapStateToProps, { getTour })( withStyles(productStyle)(TourDetailPage) );



// WEBPACK FOOTER //
// ./src/views/TourDetailPage/TourDetailPage.jsx